{{#if local}}
  <div class="survey-redirect">
    {{t "surveyRedirectLocal"}} <code>{{slug}}</code>
  </div>
  <div class="survey-redirect btn">
    <a href="#" data-navigate="forward">{{t "surveyRedirectLinkText"}}</a>
  </div>
{{else}}
  {{#if surveyCompleted}}
    <div class="survey-redirect">{{t "surveyAlreadyCompleted"}}</div>
  {{else}}
    <div class="survey-redirect">{{t "surveyRedirect"}}</div>
    <div class="survey-redirect">{{t "surveyRedirectText"}} 
      <button class="btn btn-default" id="survey_redirect_button">{{t 'surveyRedirectLinkText'}}</button>
    </div>
  {{/if}}
{{/if}}
